import { expVal } from '@atlassian/jira-feature-experiments';

const JiraAgentSessionCardExperimentRelayProvider = {
	get(): boolean {
		return expVal('agent-session-card', 'isEnabled', false);
	},
};

export default JiraAgentSessionCardExperimentRelayProvider;
